<template>
  <div class="side-edit-content p-5">
    <strong class="title-main">{{ $t('views.seller.integrations.config.edit.title') }}</strong>
    <p class="subtitle d-block mt-3 mb-4">
      {{ $t('views.seller.integrations.config.edit.product') }}:
      <strong> {{ editGroupData?.product?.name }}</strong>
    </p>

    <!-- Exibe token -->
    <div :class="isInputError('update_token')" @click="removeError('update_token')">
      <strong class="title-medium">API Key</strong>
      <div class="d-flex bd-highlight">
        <div class="flex-grow-1 bd-highlight">
          <b-form-group id="fieldset-url" label-for="input-url">
            <b-form-input id="input-url" placeholder="Informe o API Key do Memberkit" class="form-input" v-model="token" @change="updateConnection" trim></b-form-input>
          </b-form-group>
        </div>
      </div>
      <span class="show-error">
        {{ showError('update_token') }}
      </span>
    </div>

    <!-- Exibe lista de items -->
    <div :class="isInputError('update_items')" @click="removeError('update_items')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left" v-if="editGroupData?.data?.access === 'subscription'">Assinatura</strong>
        <strong class="title-medium float-left" v-else>Turma/Curso</strong>
        <template v-if="editGroupData?.data?.access === 'classroom'">
          <a href="#" @click.prevent="selectAllEdit('items')" class="select-all float-right">
            {{ items?.value?.length > 0 ? $t('views.seller.integrations.config.save.product.remove_all') : $t('views.seller.integrations.config.save.product.select_all') }}
          </a>
        </template>
      </div>
      <template v-if="editGroupData?.data?.access === 'subscription'">
        <multiselect 
          v-model="items.value"
          :options="items.items" 
          :multiple="false" 
          :show-labels="false" 
          :searchable="true"
          :loading="items.loading"
          :disabled="items.block"
          placeholder="Digite para pesquisar"
          class="new-style"
          track-by="name"
          label="name"
        >
            <template #option="props">
              <span class="d-flex option__item">{{ props.option.name }}</span>
            </template>
            <template #placeholder>
              <span class="select-title">Selecione a opcao desejada</span>
            </template>
            <template #caret>
              <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
            </template>
            <span slot="noOptions">Nenhum item disponível</span>
        </multiselect>
      </template>
      <template v-else>
        <multiselect 
          v-model="items.value"
          :options="items.items" 
          :multiple="true" 
          :taggable="false"
          :show-labels="false" 
          :clear-on-select="false" 
          :close-on-select="false"
          :searchable="true"
          :loading="items.loading"
          :disabled="items.block"
          :select-label="'Select'"
          placeholder="Digite para pesquisar"
          class="new-style"
          track-by="name"
          label="name"
          :limit-text="limitText" 
          :limit="4"
        >
          <template #option="props">
            <span class="d-flex option__item">
              <img :src="isOptionSelectedEdit(props.option.id)" />
              {{ props.option.name }}
            </span>
          </template>
          <template #placeholder>
            <span class="select-title">Selecione os itens desejados</span>
          </template>
          <span slot="noOptions">Nenhum item disponível</span>
          <span slot="noResult">Nenhum item encontrado</span>
          <div slot="limit" class="multiselect__tag limit">+{{ items?.value?.length - 4 }}</div>
          <template #caret>
            <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
          </template>
        </multiselect>
      </template>
      <span class="show-error">{{ showError('update_items') }}</span>
    </div>

  </div>
</template>

<script>

import Multiselect from 'vue-multiselect';
import MemberKitService from "@/services/resources/MemberKitService";
import ConnectionService from '@/services/resources/ConnectionService';
import ReleaseRuleService from "@/services/resources/ReleaseRuleService";

export default {
  name: "IntegrationsConfigUpdateMemberkit",
  components: {
    Multiselect
  },
  props: {
    opendEdit: {
      type: Boolean,
      required: true
    },
    loadingUpdate: {
      type: Boolean,
      required: true
    },
    editGroupLoad: {
      type: Boolean,
      required: true
    },
    integration: {
      type: Object,
      required: true,
      default: () => ({ name: 'Memberkit' })
    },
    products: {
      type: Object,
      required: true,
      default: () => ({
        value: null,
        items: [
          {
            group: {
              name: '',
            },
            options: [],
          }
        ],
      })
    },
    mountInputError: {
      type: Function,
      required: true
    },
    isInputError: {
      type: Function,
      required: true
    },
    removeError: {
      type: Function,
      required: true
    },
    removeErrors: {
      type: Function,
      required: true
    },
    showError: {
      type: Function,
      required: true
    },
    fetchCallbacks: {
      type: Function,
      required: true
    },
    limitText: {
      type: Function,
      required: true
    },
  },
  data: () => ({
    editGroupData: {},
    token: '',
    items: {
      block: true,
      loading: false,
      value: null,
      items: []
    }
  }),
  methods: {
    async showEditCallback(data) {

      this.removeErrors([
        'update_token',
        'update_items'
      ]);

      this.editGroupData = data;

      this.$emit('update:opendEdit', true);
      this.$emit('update:editGroupLoad', true);
      this.$emit('update:loadingUpdate', false);
      this.$emit('update:productSelected', data.product.id);

      await this.getIntegrationToken(data.data.connection_id);
      await this.listItemsMemberkit(data.data.access, true);

      this.$emit('update:editGroupLoad', false);
    },
    async getIntegrationToken(id) {
      await ConnectionService.build().read(id, { suppressErrorNotify: true })
      .then(response => {
        const data = JSON.parse(response.data);
        this.token = data.api_key;
      })
      .catch(() => {
        this.mountInputError({ token: ['Token não encontrado'] }, 'update_');
      });
    },
    async listItemsMemberkit(option, compare) {
      // Limpa o array de items
      this.items.value = [];

      // Verifica se a opção foi fornecida
      if (!option) {
        this.items.block = true;
        this.items.loading = false;
        return;
      }

      // Inicia o estado de carregamento
      this.items.loading = true;

      try {

        const response = await MemberKitService.build().read(`${option}?token=${this.token}`, { suppressErrorNotify: true });
  
        // Define block como false após obter resposta
        this.items.block = false;
        let items = response;

        // Modifica os itens se a opção for 'classroom'
        if (option === 'classroom') {
          items = items.map(item => ({
            ...item,
            name: `${item.course_name} | ${item.name}`,
          }));
        }

        // Se compare, verifica os itens em editGroupData e add em items.value
        if (compare) {
          if (option === 'classroom') {
            const values = items.filter(item => this.editGroupData.data.classroom_ids.includes(item.id));
            this.items.value = values;
          }
          else if (option === 'subscription') {
            const value = items.find(item => item.id === this.editGroupData.data.membership_id);
            this.items.value = value;
          }
        }

        this.items.items = items;
        
      } catch (error) {
        // Define items como vazio e block como true em caso de erro
        this.items.items = [];
        this.items.block = true;
      } finally {
        // Finaliza o estado de carregamento
        this.items.loading = false;
      }
    },
    async updateConnection() {
      try {
        await MemberKitService.build().read(`test?token=${this.token}`, { suppressErrorNotify: true });
        await this.listItemsMemberkit(this.editGroupData.data.access, false);
      }
      catch (err) {
        this.mountInputError({ token: ['Token inválido'] }, 'update_');
        this.items.value = null;
        this.items.block = true;
        this.items.items = [];
      }
    },
    updateCallbacks() {

      this.$emit('update:loadingUpdate', true);

      const data = {
        token: this.token,
      };

      if (this.editGroupData.data.access === 'subscription') {
        data.membership_id = this.items?.value?.id;
        data.membership_name = this.items?.value?.name;
      } else if (this.editGroupData.data.access === 'classroom') {
        data.classroom_ids = this.items?.value?.map(item => item.id);
        data.classroom_names = this.items?.value?.map(item => item.name);
      }

      ReleaseRuleService.build().put(`/group/memberkit/${this.editGroupData.id}`, data, { suppressErrorNotify: true })
      .then(() => {

        this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.update.success.message'), {
            title: this.$t('views.seller.integrations.config.toast.update.success.title'),
            variant: "success",
            autoHideDelay: 5000,
            appendToast: true,
        });

        this.$emit('update:opendEdit', false);
        this.fetchCallbacks();
      })
      .catch(err => {
        
        if (this.items.block && !err.response.data.token) {
          err.response.data.token = ['Token inválido'];
        }
        else if (!this.items.block && err.response.data.access) {
          err.response.data.items = ['Selecione a opção desejada'];
        }
        else if (err.response.data.membership_id || err.response.data.classroom_ids) {
          err.response.data.items = ['Selecione a opção desejada'];
        }

        this.mountInputError(err.response.data, 'update_');

        this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.update.error.message'), {
          title: this.$t('views.seller.integrations.config.toast.update.error.title'),
          variant: "danger",
          autoHideDelay: 5000,
          appendToast: true,
        });
      })
      .finally(() => {
        this.$emit('update:loadingUpdate', false);
      });
    },
    isOptionSelectedEdit(option) {
      return this.items?.value?.find(item => item.id === option)
        ? require('@/assets/img/icons/checkbox-area-selected.svg')
        : require('@/assets/img/icons/checkbox-area.svg');
    },
    selectAllEdit() {
      if (this.editGroupVariables.length > 0) {
        this.editGroupVariables = [];
      } else {
        let allOptions = [];
        this.variable.items.forEach(item => {
          allOptions = allOptions.concat(item.options);
        });
        this.editGroupVariables = allOptions;
      }
    },
  }
}
</script>

